'use client';

import { createContext, useContext } from 'react';

import { usePathname } from 'next/navigation';

import { LANGUAGES } from '@crehana/ts-types';

import { useTalentAuth } from '../TalentAuth';
import { getLanguageUser } from '../utils';

type TContext = LANGUAGES;

type TLanguageProviderProps = {
  children: React.ReactNode;
  language: LANGUAGES;
};

const Context = createContext<TContext | undefined>(undefined);

export const LanguageProvider = ({
  children,
  language,
}: TLanguageProviderProps) => {
  const { user } = useTalentAuth();
  const pathname = usePathname();
  const languageUser = getLanguageUser(pathname, user) || language;
  return <Context.Provider value={languageUser}>{children}</Context.Provider>;
};

export const useLanguage = () => {
  const result = useContext(Context);
  if (typeof result === 'undefined') {
    throw new Error(
      'The useLanguage hook must be used within a LanguageProvider component.',
    );
  }
  return result;
};
